<template>
  <div>
    {{ toJurisdictionValues() }}
  </div>
</template>

<script>
  export default {
    name: 'JurisdictionsColumn',
    props: {
      jurisdictions: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      toJurisdictionValues () {
        if (this.jurisdictions) {
          return this.jurisdictions.map(it => it.key).join(", ");
        }
        return "";
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
